import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useInitOfSavingClearPath } from '../../hooks/useBackButton'
import usePageLoaded from '../../hooks/usePageLoaded'

import Grid from '../../components/grid/grid'
import Title from '../../components/ui/title/title'
import ContributionPreview from '../../components/contribution/contributionPreview'
import IndexFilters from './indexFilters'
import AdvGroup from '../../components/AdvGroup/advGroup'
import PaginationLoader from '../../components/ui/paginationLoader/PaginationLoader'
import PaginationAndEndlessScrollWrapper from './PaginationAndEndlessScrollWrapper'

import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import Pagination from 'rsuite/Pagination'
import { Formik } from 'formik'

import { ContributionType } from '../../store/contributions/contributionsTypings'
import { RootState } from '../../store/rootReducer'
import moment from 'moment-mini'
import { ScrolledPageAmountAndPositionType } from '../../store/common/commonSliceTyping'

import isNumber from 'lodash/isNumber'
import { changeDefaultPageScrolledPagesAmountAndPosition, openMenu } from '../../store/common/commonSlice'
import { PaginationIndexLink } from '../../components/ui/paginationLink/PaginationLink'
import {
    clearContributionsList,
    fetchIndexContributions,
    setIndexFilters
} from '../../store/contributions/contributionsSlice'
import { getLangFromPath } from '../../i18next'
import '../app.sass'
import './pagination.sass'
import Button from '../../components/ui/button'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import paths from '../../paths'
import SeoIndex from '../../components/SeoInfornation/SeoIndex/SeoIndex'
import useProtectImages from '../../hooks/useProtectImages'

export type initialValuesTypes = {
    material: number
    gender: number
    certified: number
    free: number
    // dateFrom: moment().subtract(1, 'years').format('YYYY/MM/DD'),
    // When uncommenting the previous line you need to uncomment FiltersBlock.tsx line 23
    dateFrom: string
    dateTo: string
    periodToSend: string
    period: number
    limit: number
}

export const initialValues = () => {
    return {
        material: 0,
        gender: 0,
        certified: 0,
        free: 0,
        dateFrom: '2003/09/30',
        dateTo: moment().format('YYYY/MM/DD'),
        periodToSend: (() =>
            moment().subtract(1, 'years').format('DD/MM/YYYY') + '-' + moment().format('DD/MM/YYYY'))(),
        period: 0,
        limit: 10
    }
}

const AMOUNT_OF_CONTRIBUTIONS_ON_PAGE = 10
const API_MATERIAL_FORMATTER = ['photo-and-video', 'photo', 'video']
const API_GENDER_FORMATTER = ['', 'female-or-couple', 'male']
// @ts-ignore
export const formikValuesToApiConvertor = (value, page = 1) => {
    return {
        material: API_MATERIAL_FORMATTER[value.material],
        gender: API_GENDER_FORMATTER[value.gender],
        certified: value.certified,
        free: value.free,
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
        p: page,
        timestamp: Number(new Date()),
        limit: 10
    }
}

export let initialValuesClone = { ...initialValues() }

interface Props {
    newInitialValues?: initialValuesTypes
    title?: string
}

const IndexDefaultComponent = ({ newInitialValues = null, title = '' }: Props): JSX.Element => {
    usePageLoaded()
    useInitOfSavingClearPath()

    const [t] = useTranslation()
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()

    const list = useSelector<RootState, ContributionType[]>((state) => state.contributions.list)
    const loading = useSelector<RootState, boolean>((state) => state.contributions.loading)
    const total_count = useSelector<RootState, number>((state) => state.contributions.total_count)
    const scrolledPagesAmountAndPosition = useSelector<RootState, ScrolledPageAmountAndPositionType>(
        (state) => state.common.scrolledPagesAmountAndPosition
    )
    const isAgeVerified = useSelector<RootState, boolean>((state) => state.common.isAgeVerified)
    const member = useSelector((state: RootState) => state.member)

    useProtectImages(list.length)

    const pageFromAdress = () => {
        if (location.search && new URLSearchParams(location.search).get('p'))
            return Number(new URLSearchParams(location.search).get('p'))
        return undefined
    }

    const [showFilters, setShowFilters] = useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState(
        isNumber(pageFromAdress()) ? pageFromAdress() : scrolledPagesAmountAndPosition.pages
    )
    const [showIndexDescription, setShowIndexDescription] = useState(true)
    const lastElement = useRef(null)

    const [externalValues, setExternalValues] = useState(newInitialValues)

    const handleUploadContribution = () =>
        member.loggedIn ? history.push(createLocalizedPath(paths.submitContribution.path)) : dispatch(openMenu())

    const setIndexVisitedTrue = () => {
        localStorage.setItem('indexVisited', 'true')
    }

    const getIndexVisited = () => localStorage.getItem('indexVisited')

    useEffect(() => {
        if (getIndexVisited()) {
            setShowIndexDescription(false)
        } else {
            setTimeout(() => {
                setIndexVisitedTrue()
                setShowIndexDescription(false)
            }, 3000)
        }
    }, [])

    useLayoutEffect(() => {
        if (getIndexVisited()) setShowIndexDescription(false)
    }, [])

    return (
        <PaginationAndEndlessScrollWrapper
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            list={list}
            sourcePage={'indexScrolling'}
            clearList={clearContributionsList()}
            fetchList={fetchIndexContributions(
                formikValuesToApiConvertor(externalValues || initialValuesClone, currentPage)
            )}
            lastElement={lastElement}
            total={total_count}
            loading={loading}
        >
            <Formik
                initialValues={externalValues || initialValuesClone || initialValues()}
                onSubmit={(values): void => {
                    dispatch(clearContributionsList())
                    dispatch(setIndexFilters(formikValuesToApiConvertor(values)))
                    setCurrentPage(1)
                    dispatch(changeDefaultPageScrolledPagesAmountAndPosition())
                    initialValuesClone = { ...values }
                    setExternalValues(null)
                    showFilters && setShowFilters(false)
                    if (pageFromAdress()) {
                        history.push({
                            pathname: location.pathname,
                            search: `p=1`
                        })
                    } else {
                        dispatch(fetchIndexContributions(formikValuesToApiConvertor(values, 1)))
                    }
                }}
                onReset={(): void => {
                    dispatch(setIndexFilters(null))
                    dispatch(changeDefaultPageScrolledPagesAmountAndPosition())
                    initialValuesClone = { ...(newInitialValues || initialValues()) }
                    setExternalValues(null)
                    setShowFilters(false)
                    dispatch(clearContributionsList())
                    setCurrentPage(1)
                    if (pageFromAdress()) {
                        history.push({
                            pathname: location.pathname,
                            search: `p=1`
                        })
                    } else {
                        dispatch(fetchIndexContributions(formikValuesToApiConvertor(initialValues(), 1)))
                    }
                }}
            >
                <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
                    <Helmet>
                        <title>{META.index[getLangFromPath(location.pathname)].title}</title>
                        <meta name="description" content={META.index[getLangFromPath(location.pathname)].description} />
                    </Helmet>
                    <Title text={t(title || 'Index title')} />
                    <IndexFilters
                        showMoreFilters={showFilters}
                        setShowMoreFilters={setShowFilters}
                        initialValues={initialValues()}
                        initialValuesClone={externalValues || initialValuesClone}
                    />
                    <AdvGroup isAgeVerified={isAgeVerified} />
                    <div className={'pageRow_responsive'}>
                        <Title text={t('Amateur contributions')} h2h secondary />
                        <div className={'headerButtons'}>
                            <img
                                className={showIndexDescription ? 'arrowTop' : 'arrowBottom'}
                                src={require('./../../assets/ic-slider-arrow.svg')}
                                alt={'Arrow to down'}
                                onClick={() => setShowIndexDescription((prev) => !prev)}
                            />
                            <Button onClick={handleUploadContribution} label={t('Upload contributions')} secondary />
                        </div>
                    </div>
                    {<SeoIndex show={showIndexDescription} />}
                    <Grid
                        items={list.map((contribution: ContributionType) => (
                            <ContributionPreview
                                contribution={contribution}
                                key={contribution.id}
                                isAgeVerified={isAgeVerified}
                            />
                        ))}
                    />
                    <div className="paginationWrapper">
                        {!loading ? (
                            <Pagination
                                ref={lastElement}
                                limit={AMOUNT_OF_CONTRIBUTIONS_ON_PAGE}
                                limitOptions={[10]}
                                maxButtons={5}
                                linkAs={PaginationIndexLink}
                                activePage={pageFromAdress() || scrolledPagesAmountAndPosition.pages}
                                onChangePage={(page: number) => {
                                    history.push({
                                        pathname: location.pathname,
                                        search: `p=${page}`
                                    })
                                }}
                                total={+total_count}
                            />
                        ) : (
                            <PaginationLoader />
                        )}
                    </div>
                </div>
            </Formik>
        </PaginationAndEndlessScrollWrapper>
    )
}

export default IndexDefaultComponent
